<template>
  <div class="calcFormsForm">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading...
    </div>
    <div v-else-if="exitFormItem">
      <v-form ref="exitFormsForm" v-model="isFormValid" lazy-validation>
        <div>
          <v-text-field
            v-model="exitFormItem.Form"
            label="Exit form"
            :readonly="!newFormItem"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="exitFormItem.QualifyingTest"
            label="Qualifying test"
            append-icon="mdi-arrow-down-bold-box"
            :readonly="!showFormButtons"
            @click:append="openCalculationSelection('QualifyingTest')"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="exitFormItem.MaximumCash"
            label="Maximum cash"
            append-icon="mdi-arrow-down-bold-box"
            :readonly="!showFormButtons"
            @click:append="openCalculationSelection('MaximumCash')"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="exitFormItem.MinimumPension"
            label="Minimum pension"
            append-icon="mdi-arrow-down-bold-box"
            :readonly="!showFormButtons"
            @click:append="openCalculationSelection('MinimumPension')"
            dense
            outlined
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <div class="mt-6 mb-4"><strong>Plot Items</strong></div>
        <div class="plotItemsContainer">
          <div v-for="item in plotItems" :key="item.originalIndex" class="plotItem">
            <v-text-field
              v-model="item.PlotCalc"
              :label="item.FieldLabel"
              append-icon="mdi-arrow-down-bold-box"
              :readonly="!showFormButtons"
              @click:append="openCalculationSelection('Details', item.originalIndex)"
              dense
              outlined
            ></v-text-field>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="mt-6 mb-4"><strong>Contribution Plotting</strong></div>
        <div class="plotItemsContainer">
          <div v-for="item in contributionItems" :key="item.originalIndex" class="contributionItem">
            <v-select
              v-model="item.PlotCalc"
              :label="item.FieldLabel"
              :items="exitFields"
              item-text="Label"
              item-value="FieldName"
              :readonly="!showFormButtons"
              dense
              outlined
              placeholder="select calculated value"
              persistent-placeholder
              class="italic-placeholder"
            >
              <template v-slot:prepend>
                <v-icon
                  small
                  class="ml-1 mt-1"
                  @click.stop="deleteContributionPlot(item)"
                  color="gray"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-select>
          </div>

          <v-btn
            v-if="!newContributionPlot"
            color="primary"
            class="mb-5"
            @click="newContributionPlot = true"
            >+</v-btn
          >
          <v-select
            v-else
            label="Contribution Name"
            :items="salaryFields"
            :item-text="'Label'"
            :item-value="(item) => item"
            dense
            outlined
            @change="addContributionPlot"
            placeholder="select contribution field"
            persistent-placeholder
            class="italic-placeholder"
          ></v-select>
        </div>
        <v-divider></v-divider>
        <div class="mt-6 mb-4"><strong>Additional Items</strong></div>
        <div class="plotItemsContainer">
          <div v-for="item in additionalItems" :key="item.originalIndex" class="additionalItem">
            <v-text-field
              v-model="item.PlotCalc"
              :label="item.FieldLabel"
              append-icon="mdi-arrow-down-bold-box"
              :readonly="!showFormButtons"
              @click:append="openCalculationSelection('Details', item.originalIndex)"
              dense
              outlined
              placeholder="select a calculation item"
              persistent-placeholder
              class="italic-placeholder"
            >
              <template v-slot:prepend>
                <v-icon
                  small
                  class="ml-1 mt-1"
                  @click.stop="deleteContributionPlot(item)"
                  color="gray"
                >
                  mdi-delete
                </v-icon>
              </template></v-text-field
            >
          </div>

          <v-btn color="primary" class="mb-5" @click="addAdditionalItem">+</v-btn>
          
        </div>
      </v-form>
      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCancel" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert type="info" outlined dense>No info found for this element</v-alert>
    </div>
    <CalculationSelection
      ref="calculationSelection"
      :levelId="planId"
      @select="onSelect"
      :exitForm="exitFormItem.Form"
    />
  </div>
</template>

<script>
import CalculationSelection from './Popups/CalculationSelection.vue';

export default {
  name: 'exitFormsForm',
  components: {
    CalculationSelection,
  },
  props: {
    exitId: {type: Number},
    planId: { type: Number },
    groupId: { type: Number, default: 0 },
  },

  data() {
    return {
      loading: false,
      isFormValid: false,
      exitFormItem: null,
      rules: [(v) => !!v || 'Required.'],
      salaryFields: [],
      exitFields: [],

      calculationSelectionProperty: null,
      selectedIndex: null,

      newContributionPlot: false,
      newFormItem : false,

      plotItems: [],
      contributionItems: [],
      additionalItems: [],
    };
  },

  computed: {
    levelsList() {
      return [
        { text: 'System', value: 0 },
        { text: 'Plan', value: this.currentPlanId },
      ];
    },
    selectedLevel() {
      if (this.exitFormItem) {
        return this.exitFormItem.PlanId;
      }
      return null;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    async exitId() {
      if (this.exitId) await this.getForm(this.exitId);
      else this.createNewForm();
      this.newContributionPlot = false;
      this.getExitFields();
      this.getSalaryFields();
    },

    'exitFormItem.Details': {
      handler() {
        if (this.exitFormItem && this.exitFormItem.Details.length > 0) {
          this.plotItems = this.exitFormItem.Details.map((d, originalIndex) => {
            d.originalIndex = originalIndex;
            return d;
          }).filter((d) => d.FieldName.indexOf('Salary.') < 0 && d.FieldName !== 'ReportItem');

          this.contributionItems = this.exitFormItem.Details.map((d, originalIndex) => {
            d.originalIndex = originalIndex;
            return d;
          }).filter((d) => d.FieldName.indexOf('Salary.') == 0);

          this.additionalItems = this.exitFormItem.Details.map((d, originalIndex) => {
            d.originalIndex = originalIndex;
            return d;
          }).filter((d) => d.FieldName == 'ReportItem');

          console.log(this.exitFormItem);
        }
      },
      deep: true,
    },
  },

  async created() {
    if (this.exitId) await this.getForm(this.exitId);
    else this.createNewForm();
    this.getExitFields();
    this.getSalaryFields();
  },

  methods: {
    createNewForm() {
      this.newContributionPlot = false;
      this.newFormItem = true;
      this.exitFormItem = {
        QualifyingTest: '',
        MaximumCash: '',
        MinimumPension: '',
        InputForm: '',
        ExitPlotId: this.exitId,
        PlanId: this.planId,
        GroupId: this.groupId,
        Form: '',
        Details: [],
      };
    },

    addContributionPlot(item) {
      this.exitFormItem.Details.push({
        ExitPlotId: 0,
        FieldLabel: item.Label,
        FieldName: item.FieldName,
        PlotCalc: '',
      });
      this.newContributionPlot = false;
    },

    addAdditionalItem() {
      this.exitFormItem.Details.push({
        ExitPlotId: 0,
        FieldLabel: 'Calculation Item',
        FieldName: 'ReportItem',
        PlotCalc: '',
      });
    },

    deleteContributionPlot(item) {
      const index = this.exitFormItem.Details.findIndex(
        (d) => d.FieldName === item.FieldName && d.PlotCalc === item.PlotCalc
      );
      if (index !== -1) {
        this.exitFormItem.Details.splice(index, 1);
      }
    },

    onCancel() {
      if (this.exitId) this.getForm(this.exitId);
      else this.createNewForm();
    },

    onSave() {
      const isFormValid = this.$refs.exitFormsForm.validate();
      if (isFormValid) this.updateForm();
    },

    openCalculationSelection(property, index) {
      if (!this.showFormButtons) return;
      this.calculationSelectionProperty = null;
      this.selectedIndex = null;
      if (index >= 0) {
        this.selectedIndex = index;
      }
      this.calculationSelectionProperty = property;
      this.$refs.calculationSelection.open();
    },

    onSelect(val) {
      if (this.calculationSelectionProperty === 'Details' && this.selectedIndex >= 0) {
        this.exitFormItem.Details[this.selectedIndex].PlotCalc = val;
      } else {
        this.exitFormItem[this.calculationSelectionProperty] = val;
      }
    },

    async getExitFields() {
      try {
        //let exitId = encodeURIComponent(this.exitId);
        /*if (this.exitId.includes('+')) {
          exitId = this.exitId.replace('+', '%2B');
        } else {
          exitId = this.exitId;
        }*/
        
        let response = await this.$api.get(
          `/CalculationPlotting/GetPlottingElementsList?planId=${this.planId}&groupId=${this.groupId}&key=${this.exitFormItem.Form}`
        );

        if (!response.data) {
          const msg = 'Unable to load contribution plotting elements';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.exitFields = response.data;

        console.log(this.exitFields);
      } catch (err) {
        console.log(err);
      } finally {
        //
      }
    },

    async getSalaryFields() {
      try {
        let response = await this.$api.get(
          `/CalculationPlotting/GetPlottingElementsList?planId=${this.planId}&groupId=${this.groupId}&key=Salary`
        );

        if (!response.data) {
          const msg = 'Unable to load contribution plotting elements';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.salaryFields = response.data;

        this.salaryFields.forEach((item) => {
          item.FieldName = `Salary.${item.FieldName}`;
        });

        console.log(this.salaryFields);
      } catch (err) {
        console.log(err);
      } finally {
        //
      }
    },

    async getForm() {
      this.exitFormItem = null;
      this.newFormItem = false;
      this.loading = true;
      this.newContributionPlot = false;
      let exitId = encodeURIComponent(this.exitId);
      /*if (this.exitId.includes('+')) {
        exitId = this.exitId.replace('+', '%2B');
      } else {
        exitId = this.exitId;
      }*/

      try {
        let response = await this.$api.get(
          `/CalculationPlotting/GetPlottingDetails?planId=${this.planId}&groupId=${this.groupId}&key=${exitId}`
        );

        if (!response.data) {
          const msg = 'Unable to load plotting details';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        var data = response.data;

        this.exitFormItem = data;

        console.log(this.exitFormItem);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async updateForm() {
      try {
        let response = await this.$api.post(
          '/CalculationPlotting/UpdatePlotting',
          this.exitFormItem
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Form item is saved',
        });
        if (this.exitFormItem.exitId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
          this.getForm();
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.italic-placeholder input::placeholder {
  font-style: italic;
}
</style>
